/* MCR · product page helpers: sticky add-to-cart, coupon copy, share, delivery estimator,
   size chart (tabs, in/cm, fit finder) and recently-viewed tracking. Vanilla, deferred. */
(function () {
  'use strict';
  if (window.MCRProduct) return;
  var doc = document;
  var cfg = window.MCRConfig || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || cfg.moneyFormat || '₹{{amount}}';
    function delim(num, precision, thousands, decimal) {
      if (isNaN(num) || num == null) return '0';
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      default: value = delim(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function toast(msg) {
    if (window.MCR && window.MCR.toast) window.MCR.toast(msg);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve) {
      var ta = doc.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      doc.body.appendChild(ta);
      ta.select();
      try { doc.execCommand('copy'); } catch (e) {}
      ta.remove();
      resolve();
    });
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky(bar) {
    if (bar.__mcr) return;
    bar.__mcr = true;
    var section = bar.dataset.section;
    var btn = bar.querySelector('[data-mcr-sticky-submit]');
    function main() { return doc.getElementById('ProductSubmitButton-' + section); }
    var target = main();
    var mobileMq = window.matchMedia('(max-width: 749px)');
    if (!target || !('IntersectionObserver' in window)) return;

    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      doc.body.classList.toggle('mcr-has-sticky-atc', on);
    }
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // Desktop: after scrolling past the button. Mobile: also while it is still below the first screen.
      setVisible(!e.isIntersecting && (e.boundingClientRect.top < 0 || mobileMq.matches));
    });
    io.observe(target);

    btn.addEventListener('click', function () {
      var m = main();
      if (!m || m.disabled || m.getAttribute('aria-disabled') === 'true') {
        if (m) m.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      m.click();
    });

    // keep in sync with Dawn variant changes
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var d = payload && payload.data;
        if (!d || d.sectionId !== section) return;
        var v = d.variant;
        var nt = main();
        if (nt !== target && nt) { io.unobserve(target); target = nt; io.observe(target); }
        var label = bar.querySelector('[data-mcr-sticky-label]');
        var vt = bar.querySelector('[data-mcr-sticky-variant]');
        var price = bar.querySelector('[data-mcr-sticky-price]');
        var img = bar.querySelector('.mcr-sticky-atc__media img');
        if (!v) {
          btn.disabled = true;
          if (label) label.textContent = bar.dataset.labelUnavailable;
          return;
        }
        if (vt) {
          // clean names from the picker (ABLUE → Blue); data stays raw
          var vs = document.getElementById('variant-selects-' + section);
          var labs = vs ? Array.prototype.map.call(vs.querySelectorAll('input:checked, option:checked'), function (i) { return i.dataset.mcrLabel; }).filter(Boolean) : [];
          vt.textContent = labs.length ? labs.join(' / ') : v.title;
        }
        if (price) {
          price.innerHTML = '';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            var s = doc.createElement('s');
            s.textContent = formatMoney(v.compare_at_price);
            price.appendChild(s);
          }
          var st = doc.createElement('strong');
          st.textContent = formatMoney(v.price);
          price.appendChild(st);
        }
        btn.disabled = !v.available;
        if (label) label.textContent = v.available ? bar.dataset.labelAdd : bar.dataset.labelSoldout;
        if (img && v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
          var src = v.featured_media.preview_image.src;
          img.removeAttribute('srcset');
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        }
      });
    }
  }

  /* ---------- delivery estimator ---------- */
  function addBusinessDays(date, days, skipSunday) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (skipSunday && d.getDay() === 0) continue;
      added++;
    }
    if (skipSunday && d.getDay() === 0) d.setDate(d.getDate() + 1);
    return d;
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { return d.toDateString(); }
  }
  var PIN_KEY = 'mcr:pin';
  function initDelivery(box) {
    if (box.__mcr) return;
    box.__mcr = true;
    var form = box.querySelector('form');
    var input = box.querySelector('input');
    var out = box.querySelector('[data-mcr-delivery-result]');
    var remember = box.dataset.remember === 'true';
    function run(save) {
      var pin = (input.value || '').replace(/\D/g, '');
      input.value = pin;
      if (!/^[1-9][0-9]{5}$/.test(pin)) {
        out.classList.add('is-error');
        out.textContent = box.dataset.error;
        input.setAttribute('aria-invalid', 'true');
        return;
      }
      input.removeAttribute('aria-invalid');
      var skip = box.dataset.skipSunday === 'true';
      var min = parseInt(box.dataset.min, 10) || 3;
      var max = Math.max(min, parseInt(box.dataset.max, 10) || min);
      var now = new Date();
      var start = addBusinessDays(now, min, skip);
      var end = addBusinessDays(now, max, skip);
      var msg = (box.dataset.message || '[start] – [end]');
      out.classList.remove('is-error');
      out.innerHTML = '';
      // build safely: split on tokens
      msg.split(/(\[pin\]|\[start\]|\[end\])/).forEach(function (part) {
        if (part === '[pin]') { out.appendChild(doc.createTextNode(pin)); }
        else if (part === '[start]' || part === '[end]') {
          var s = doc.createElement('strong');
          s.textContent = fmtDate(part === '[start]' ? start : end);
          out.appendChild(s);
        } else if (part) out.appendChild(doc.createTextNode(part));
      });
      if (save && remember) { try { localStorage.setItem(PIN_KEY, pin); } catch (e) {} }
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); run(true); });
    input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
    if (remember) {
      try {
        var saved = localStorage.getItem(PIN_KEY);
        if (saved) { input.value = saved; run(false); }
      } catch (e) {}
    }
  }

  /* ---------- size chart ---------- */
  function initSizeChart(modal) {
    if (modal.__mcr) return;
    modal.__mcr = true;
    var tabs = Array.prototype.slice.call(modal.querySelectorAll('[data-mcr-tab]'));
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.classList.toggle('is-active', on);
        t.tabIndex = on ? 0 : -1;
        var p = doc.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        select(n);
        n.focus();
      });
    });

    // unit conversion
    var table = modal.querySelector('[data-mcr-sc-table]');
    var units = modal.querySelector('[data-mcr-units]');
    var base = modal.dataset.baseUnit === 'cm' ? 'cm' : 'in';
    var skipFirst = modal.dataset.skipFirst !== 'false';
    var cells = [];
    if (table) {
      table.querySelectorAll('tr').forEach(function (tr) {
        Array.prototype.forEach.call(tr.children, function (c, idx) {
          if (skipFirst && idx === 0) return;
          if (c.closest('thead') || c.children.length) return;
          var txt = c.textContent.trim();
          if (/^[\d.\s\-–/]+$/.test(txt) && /\d/.test(txt)) {
            c.dataset.orig = txt;
            c.classList.add('is-converted');
            cells.push(c);
          }
        });
      });
    }
    if (units && cells.length) {
      units.hidden = false;
      var btns = units.querySelectorAll('[data-unit]');
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.unit === base ? 'true' : 'false'); });
      units.addEventListener('click', function (e) {
        var b = e.target.closest('[data-unit]');
        if (!b) return;
        var unit = b.dataset.unit;
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        cells.forEach(function (c) {
          if (unit === base) { c.textContent = c.dataset.orig; return; }
          var f = unit === 'cm' ? 2.54 : 1 / 2.54;
          c.textContent = c.dataset.orig.replace(/\d+(\.\d+)?/g, function (n) {
            var v = Math.round(parseFloat(n) * f * 10) / 10;
            return String(v).replace(/\.0$/, '');
          });
        });
      });
    }

    // fit finder
    var fit = modal.querySelector('[data-mcr-fit]');
    if (fit) {
      var map = (fit.dataset.map || '').split(/\r?\n/).map(function (l) {
        var m = l.match(/^\s*([^:]+):\s*([\d.]+)\s*[-–]\s*([\d.]+)/);
        return m ? { size: m[1].trim(), min: parseFloat(m[2]), max: parseFloat(m[3]) } : null;
      }).filter(Boolean);
      var result = fit.querySelector('[data-mcr-fit-result]');
      var lo = Math.min.apply(null, map.map(function (x) { return x.min; }));
      var hi = Math.max.apply(null, map.map(function (x) { return x.max; }));
      fit.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = parseFloat(fit.querySelector('input').value);
        var hit = null;
        if (!isNaN(val)) {
          for (var i = 0; i < map.length; i++) { if (val >= map[i].min && val <= map[i].max) { hit = map[i]; break; } }
        }
        if (table) table.querySelectorAll('tr.is-match').forEach(function (r) { r.classList.remove('is-match'); });
        result.innerHTML = '';
        if (!hit) {
          result.classList.add('is-error');
          result.textContent = (result.dataset.error || '').replace('[min]', lo).replace('[max]', hi);
          return;
        }
        result.classList.remove('is-error');
        (result.dataset.success || '[size]').split('[size]').forEach(function (part, idx, arr) {
          if (part) result.appendChild(doc.createTextNode(part));
          if (idx < arr.length - 1) {
            var s = doc.createElement('strong');
            s.textContent = hit.size;
            result.appendChild(s);
          }
        });
        if (table) {
          table.querySelectorAll('tbody tr').forEach(function (r) {
            var first = r.children[0];
            if (first && first.textContent.trim() === hit.size) r.classList.add('is-match');
          });
        }
        // preselect the matching size on the page when available
        doc.querySelectorAll('variant-selects input[type="radio"]').forEach(function (inp) {
          var name = (inp.dataset.optionName || '').toLowerCase();
          if (name.indexOf('size') > -1 && inp.value === hit.size && !inp.checked && !inp.classList.contains('disabled')) {
            inp.checked = true;
            inp.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }
  }

  /* ---------- recently viewed ---------- */
  var RV_KEY = 'mcr:recent:v1';
  function trackRecent() {
    var info = doc.querySelector('product-info[id^="MainProduct"]');
    if (!info) return;
    var m = (info.dataset.url || '').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    try {
      var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 16)));
    } catch (e) {}
  }

  /* ---------- delegated clicks: coupon copy + share ---------- */
  doc.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-mcr-copy]');
    if (c) {
      copyText(c.dataset.mcrCopy).then(function () {
        c.classList.add('is-copied');
        toast(c.dataset.copied || c.dataset.mcrCopy);
        setTimeout(function () { c.classList.remove('is-copied'); }, 2000);
      });
      return;
    }
    var s = e.target.closest && e.target.closest('[data-mcr-share-native]');
    if (s) {
      var data = { title: s.dataset.title, url: s.dataset.url };
      if (navigator.share) {
        navigator.share(data).catch(function () {});
      } else {
        copyText(data.url).then(function () { toast(s.dataset.copied); });
      }
    }
  });

  /* ---------- quantity × price: the main price, add-to-bag button and sticky bar show the total ---------- */
  function initQtyPrice(wrap) {
    if (wrap.__mcrQty || wrap.closest('quick-add-modal')) return;
    wrap.__mcrQty = true;
    var section = wrap.id.replace(/^price-/, '');
    var unit = parseInt(wrap.dataset.mcrUnit, 10) || 0;
    var compare = parseInt(wrap.dataset.mcrCompare, 10) || 0;
    function qty() {
      var i = doc.getElementById('Quantity-' + section);
      var q = i ? parseInt(i.value, 10) : 1;
      return q > 0 ? q : 1;
    }
    function setAll(sel, cents) {
      wrap.querySelectorAll(sel).forEach(function (el) { el.textContent = formatMoney(cents); });
    }
    function apply() {
      if (!unit) return;
      var q = qty(), total = unit * q;
      setAll('.price__regular span.price-item--regular', total);
      setAll('.price__sale .price-item--sale', total);
      if (compare > unit) setAll('.price__sale s.price-item--regular, .price__regular s.price-item--regular', compare * q);
      var each = wrap.querySelector('.mcr-price-each');
      if (q > 1) {
        if (!each) { each = doc.createElement('span'); each.className = 'mcr-price-each'; wrap.appendChild(each); }
        each.textContent = (wrap.dataset.mcrEach || '[price] each').replace('[price]', formatMoney(unit)).replace('[qty]', q);
        each.hidden = false;
      } else if (each) each.hidden = true;

      var btn = doc.getElementById('ProductSubmitButton-' + section);
      if (btn) {
        var tag = btn.querySelector('.mcr-atc-total');
        if (!btn.disabled) {
          if (!tag) {
            tag = doc.createElement('span');
            tag.className = 'mcr-atc-total';
            var label = btn.querySelector('span');
            if (label) label.insertAdjacentElement('afterend', tag); else btn.appendChild(tag);
          }
          tag.textContent = formatMoney(total);
          tag.hidden = false;
        } else if (tag) tag.hidden = true;
      }

      var sp = doc.querySelector('[data-mcr-sticky-atc][data-section="' + section + '"] [data-mcr-sticky-price]');
      if (sp) {
        sp.innerHTML = '';
        if (compare > unit) { var s = doc.createElement('s'); s.textContent = formatMoney(compare * q); sp.appendChild(s); }
        var st = doc.createElement('strong'); st.textContent = formatMoney(total); sp.appendChild(st);
      }
    }
    var lastQty = qty();
    function onQty(e) { if (e.target && e.target.id === 'Quantity-' + section) { lastQty = qty(); apply(); } }
    doc.addEventListener('change', onQty);
    doc.addEventListener('input', onQty);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var d = payload && payload.data;
        if (!d || d.sectionId !== section || !d.variant) return;
        unit = d.variant.price || 0;
        compare = d.variant.compare_at_price || 0;
        // Dawn re-renders the quantity box at 1 — keep the shopper's quantity (within the new limits)
        var input = doc.getElementById('Quantity-' + section);
        if (input && lastQty > 1) {
          var max = parseInt(input.getAttribute('max'), 10);
          input.value = max > 0 ? Math.min(lastQty, max) : lastQty;
          var qi = input.closest('quantity-input');
          if (qi && typeof qi.validateQtyRules === 'function') qi.validateQtyRules();
        }
        apply();
      });
    }
    apply();
  }

  /* ---------- mark genuinely sold-out variants (Dawn also disables the button while a variant loads) ---------- */
  function markSoldOut(btn, soldOut) { if (btn) btn.toggleAttribute('data-mcr-soldout', !!soldOut); }
  var soldOutWired = false;
  function initSoldOut(scope) {
    scope.querySelectorAll('.product-form__submit[id^="ProductSubmitButton-"]').forEach(function (btn) {
      if (btn.__mcrSold) return;
      btn.__mcrSold = true;
      markSoldOut(btn, btn.disabled);
    });
    if (soldOutWired || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    soldOutWired = true;
    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      var d = payload && payload.data;
      if (!d) return;
      markSoldOut(doc.getElementById('ProductSubmitButton-' + d.sectionId), !d.variant || !d.variant.available);
    });
  }

  function init(scope) {
    scope = scope || doc;
    initSoldOut(scope);
    scope.querySelectorAll('[data-mcr-sticky-atc]').forEach(initSticky);
    scope.querySelectorAll('[data-mcr-qty-price]').forEach(initQtyPrice);
    scope.querySelectorAll('[data-mcr-delivery]').forEach(function (b) { if (!b.closest('quick-add-modal')) initDelivery(b); });
    scope.querySelectorAll('[data-mcr-size-chart]').forEach(initSizeChart);
  }

  window.MCRProduct = { init: init, formatMoney: formatMoney };
  function boot() { init(doc); trackRecent(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
